import React from 'react';
import {Img1,Img2,Img3,Img4} from "../../svg/index";
import { Avatarcircle } from './AvatarCircle';

const IconProgressBar = ({indexProgress = 0}) => {
    const arrIcons = [
        <Img1/>,
        <Img2 indexProgress={indexProgress} />,
        <Img3 indexProgress={indexProgress} />,
        <Img4 indexProgress={indexProgress} />
    ];
    return (
        <div className="sg-iconbar-vsc">
           {arrIcons.map((icon,index) =>
               <Avatarcircle key={index} index={index} indexProgress={indexProgress}>
                   {icon}
               </Avatarcircle>
           )}
        </div>
    );
}

export {IconProgressBar};